export const MEDIA_UPLOADER_STRINGS = {
  BROWSE_FILES_TEXT: 'Drag and drop or browse to ',
  CHOOSE_FILE: 'choose file',
  FILE_FORMAT_TEXT: 'File formats:',
  UPLOAD_LIMIT_TEXT: 'Upload limit: 25 MB.',
  REARRANGE_TEXT: 'Click on four dots to move or rearrange photos',
  UPLOAD_ERROR:
    'The selected file exceeds your remaining upload limit of [{maximumSize}] MB. Please choose a smaller file or remove an existing one to free up space.',
  INVALID_FILE_ERROR:
    'Unsupported file format. Please upload a {extensions} image.',
  // GALLERY_UPLOAD_FILE_TYPE: 'PNG, JPG, WEBP, JFIF HEIC or HEIC',
  GALLERY_UPLOAD_FILE_TYPE: 'JEPG, PNG, JPG, WEBP or JFIF',
  DOCUMENT_UPLOAD_FILE_TYPE: 'JPEG, JPG, PNG, PDF, DOCX, XLSX, TXT',
  SINGLE_PHOTO_ONLY_ERROR:
    'Please select a single photo to be uploaded. In case you want to select another photo, delete the current photo to select a new one',
  PHOTO_LIBRARY_BUTTON: 'Open Stock Photo Library',
} as const;

export const MAX_TOTAL_FILE_SIZE = 25;
